export function logosSlider() {
	$(".logos-slider").slick({
		infinite: false,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					infinite: true,
					slidesToShow: 2.9,
					slidesToScroll: 1
				}
			}
		]
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/logosSlider.js